import { createReducer, on } from '@ngrx/store';
import { environment } from '../../app/environment/environment';
import { id } from '../interfaces/id.type';
import { ITenant } from './interfaces/tenant.interface';
import * as TenantActions from './tenant.actions';

export const tenantFeatureKey = 'tenantFeature';

export interface State {
  tenants: ITenant[];
  selectedTenantId: id | null;
}

export const initialState: State = {
  tenants: [],
  selectedTenantId: environment.defaultTenant,
};

export const reducer = createReducer(
  initialState,

  on(TenantActions.loadTenantsSuccess, (state, { tenants }): State => ({ ...state, tenants })),
  on(
    TenantActions.selectTenant,
    (state, { tenantId }): State => ({ ...state, selectedTenantId: tenantId })
  )
);
